import { useNuxtApp } from '#imports'

export function useTracking() {
  return useNuxtApp().$tracking
}
